module.exports = __webpack_public_path__ + "img/Logo-Purple.f89de729.svg";